// @ts-strict-ignore
import {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {EntryPart, MetricEntry} from 'common/query-builder/query-entry-section/types';
import {getAllSavedBehaviors} from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/behavior-utils';
import {MetricType} from 'common/types/reports/bookmark';
import {ReportName} from 'common/report/constants';

// eslint-disable-next-line import/no-cycle
import {RetentionMetricEntryRow} from './index';
import {getNewEntry} from './utils';

export const helpers: EntryRowTypeHelpers<MetricEntry> = {
  component: RetentionMetricEntryRow,
  getNewEntry: (section, type) => {
    const savedBehaviors = getAllSavedBehaviors({behaviors: section.props.behaviors, metricType: MetricType.Retention});
    return getNewEntry({
      isExpanded: section.props.reportName !== ReportName.Insights || savedBehaviors.length === 0,
      type,
    });
  },
  isPlaceholder: ({entry, sectionProps}) => {
    // "stage" metric entry only in Insights report mode. If not insights report mode, there is no "staged" state.
    // Therefore, always return false for non Insights report mode.
    if (sectionProps.reportName !== ReportName.Insights) {
      return false;
    }
    const behaviors = entry.behavior.behaviors || [];
    const metricType = entry.behavior.type;
    if (metricType === MetricType.RetentionFrequency) {
      return behaviors.length < 1 || !behaviors.every((behavior) => !!behavior.name);
    }
    return behaviors.length < 2 || !behaviors.every((behavior) => !!behavior.name);
  },
  getDefaultActiveEntryPart: ({behaviorsCtx}) => {
    const savedBehaviors = getAllSavedBehaviors({behaviors: behaviorsCtx, metricType: MetricType.Retention});
    if (savedBehaviors.length === 0) {
      return EntryPart.SubValue;
    }
    return EntryPart.Value;
  },
};
